document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('emra-bebelissimo-produse');
  if (!root) return;
  const nav = root.querySelector('.emra-bb-nav');
  const grid = root.querySelector('#product-grid');
  if (!nav || !grid) return;
  const cards = Array.from(grid.querySelectorAll(':scope > li[data-emra-bb-kind]'));
  const controls = Array.from(nav.querySelectorAll('[data-emra-bb-filter]'));
  const counts = Object.fromEntries(['stroller2','stroller3','strollersport','carseat','highchair','other'].map(k => [k, cards.filter(c => c.dataset.emraBbKind === k).length]));
  controls.forEach(c => { if (c.dataset.emraBbFilter !== 'all' && !counts[c.dataset.emraBbFilter]) c.hidden = true; });
  const all = nav.querySelector('[data-emra-bb-filter="all"]');
  if (all) all.addEventListener('click', e => { e.preventDefault(); filter('all'); });
  controls.filter(c => c.tagName === 'BUTTON').forEach(c => c.addEventListener('click', () => filter(c.dataset.emraBbFilter)));
  function filter(kind) {
    cards.forEach(c => { c.hidden = kind !== 'all' && c.dataset.emraBbKind !== kind; });
    controls.forEach(c => { const active = c.dataset.emraBbFilter === kind; c.classList.toggle('is-active', active); c.setAttribute('aria-pressed', String(active)); });
    grid.dataset.emraActiveFilter = kind;
  }
});
